import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton, useTheme } from '@mui/material';
import * as React from 'react';

import { Drawer } from '../../components';
import { Header, Title } from '../../components/_mui';
import useWindowSize from '../../hooks/useWindowSize';
import { DrawerAnimationDirectionEnum } from '../../types/shell';

import styles from './ReceiverFixedAddressSidebar.module.scss';

interface IProps {
  onClose: () => void;
  trigger: boolean;
  children?: React.ReactNode;
}

const ReceiverFixedAddressSidebar: React.FC<IProps> = ({ trigger, onClose, children }) => {
  const { sass: variables } = useTheme();
  const { mobile } = useWindowSize();

  const from = React.useMemo(
    () => (mobile ? variables.muiSidebarMinHeight : variables.muiSidebarMinWidth),
    [mobile, variables.muiSidebarMinHeight, variables.muiSidebarMinWidth],
  );

  const to = React.useMemo(() => {
    if (mobile) {
      return variables.muiSidebarMaxWidth;
    }

    return variables.muiSidebarMaxWidth;
  }, [mobile, variables.muiSidebarMaxWidth]);

  const header = React.useMemo(
    () => (
      <>
        <Header>
          <Title variant="h6">Enter delivery address</Title>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Header>
        <p className={styles.text}>
          Enter the address where all gifts will be delivered. The recipient cannot change this address, but they can
          still select preferred gift options if available.
        </p>
      </>
    ),
    [onClose],
  );

  // Renders children instead of the standard layout to be able to show some custom UI, like custom loader, etc
  return (
    <Drawer
      className={styles.container}
      direction={mobile ? DrawerAnimationDirectionEnum.Vertically : DrawerAnimationDirectionEnum.Horizontally}
      from={from}
      to={to}
      trigger={trigger}
      onClose={onClose}
      withOverlay
      overlayClassName={styles.overlay}
    >
      {trigger && (
        <div className={styles.wrapper}>
          {header}
          {children}
        </div>
      )}
    </Drawer>
  );
};

export default ReceiverFixedAddressSidebar;
